import React from "react";
import { Grid, Typography } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/ru";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    KeyboardTimePicker,
} from "@material-ui/pickers";

const returnMoment = (data) => {
    if (!data) return undefined;
    if (!isNaN(data)) {
        return moment(Date.now() + data * 1000 * 3600 * 24);
    } else if (isNaN(data)) {
        return moment(data);
    }
};

const workWithDate = (
    pickedName,
    pickedDate,
    updater,
    prevValue = null,
    changeTimeOnly = false,
) => {
    if (!pickedDate) return;

    let resultDate;

    if (changeTimeOnly && prevValue) {
        if (!moment(pickedDate).isValid()) {
            resultDate = moment(prevValue);
        } else {
            resultDate = moment(prevValue)
                .hour(pickedDate.hour())
                .minute(pickedDate.minute())
                .second(0);
        }
    } else {
        resultDate = pickedDate;
    }

    const formattedDate = resultDate.format("YYYY-MM-DD HH:mm:ss");
    updater(pickedName, formattedDate);
};

export const dateTimeRenderer = (
    value,
    name,
    restrictionMin,
    restrictionMax,
    fieldUpdateHandler,
    mutable,
    restrictionFieldName,
    isError,
) => {
    const momentValue =
        value === null &&
        (name === "date_start_booking" || name === "date_end_booking")
            ? null
            : returnMoment(value);

    if (!mutable) {
        return (
            <Typography>
                {momentValue ? momentValue.format("DD/MM/YYYY HH:mm") : ""}
            </Typography>
        );
    }

    let momentRestrictionMax;
    let momentRestrictionMin;

    if (
        [
            "cashback_stay_date_to",
            "cashback_booking_date_to",
            "date_end",
        ].includes(restrictionFieldName)
    ) {
        momentRestrictionMax = returnMoment(restrictionMax);
    } else if (
        [
            "cashback_stay_date_from",
            "cashback_booking_date_from",
            "date_start",
        ].includes(restrictionFieldName)
    ) {
        momentRestrictionMin = returnMoment(restrictionMin);
    }

    return (
        <MuiPickersUtilsProvider utils={MomentUtils} locale="ru">
            <Grid container spacing={2}>
                <Grid item>
                    <KeyboardDatePicker
                        variant="inline"
                        inputVariant="outlined"
                        format="DD/MM/YYYY"
                        margin="normal"
                        minDate={momentRestrictionMin}
                        maxDate={momentRestrictionMax}
                        value={momentValue}
                        onChange={(date) =>
                            workWithDate(name, date, fieldUpdateHandler)
                        }
                        error={!!isError}
                        helperText={isError}
                        KeyboardButtonProps={{
                            "aria-label": "change date",
                        }}
                    />
                </Grid>
                <Grid item>
                    <KeyboardTimePicker
                        variant="inline"
                        inputVariant="outlined"
                        margin="normal"
                        value={momentValue}
                        onChange={(date) =>
                            workWithDate(
                                name,
                                date,
                                fieldUpdateHandler,
                                momentValue,
                                true,
                            )
                        }
                        error={!!isError}
                        helperText={isError}
                        KeyboardButtonProps={{
                            "aria-label": "change time",
                        }}
                        ampm={false} // 24ч формат
                    />
                </Grid>
            </Grid>
        </MuiPickersUtilsProvider>
    );
};
